package com.tixforgigs.common.http


import io.ktor.client.*
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.*

actual fun platformHttpClient(config: HttpClientConfig<*>.() -> Unit): HttpClient {
  return HttpClient(Js) {
    config(this)
  }
}
